import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Spin, Card, Typography, Empty, Tag, Button } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { format } from "date-fns";

const { Title, Paragraph, Text } = Typography;

export default function ComunicadosCliente() {
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStatements();
  }, []);

  async function loadStatements() {
    setLoading(true);
    await api
      .get(`/statements-last`)
      .then((response) => {
        setStatements(response.data);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 25,
        }}
      >
        <h1>Histórico de Comunicados</h1>
      </div>

      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: 100 }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {statements.length > 0 ? (
            statements.map((item) => (
              <Card
                key={item.id}
                hoverable
                style={{ borderRadius: 12, borderLeft: "6px solid #008037" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 12,
                  }}
                >
                  <Title level={4} style={{ margin: 0, color: "#008037" }}>
                    {item.title}
                  </Title>
                  <Tag color="green" icon={<CheckCircleOutlined />}>
                    Recebido
                  </Tag>
                </div>
                <Paragraph style={{ fontSize: 15, color: "#595959" }}>
                  {item.description}
                </Paragraph>
                <div
                  style={{
                    marginTop: 15,
                    borderTop: "1px solid #f0f0f0",
                    paddingTop: 12,
                  }}
                >
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Publicado em:{" "}
                    {item.create_at
                      ? format(new Date(item.create_at), "dd/MM/yyyy HH:mm")
                      : "N/A"}
                  </Text>
                </div>
              </Card>
            ))
          ) : (
            <Empty description="Nenhum comunicado encontrado no histórico." />
          )}
        </div>
      )}
    </Container>
  );
}
